MicroModal.init({
  disableScroll: true,
  disableFocus: true,
});

//////////////////////////////////////////////////
// 商品注意事項・年齢確認の同意チェック
//////////////////////////////////////////////////
(function () {
  'use strict';

  const modalReference = document.getElementById('modal-reference');
  const strSoldOut = modalReference?.dataset.soldOut || '';
  const addToCartButton = document.querySelector('button.product-form__submit');
  if (addToCartButton == null) return;

  const addToCartText = addToCartButton.querySelector('span');
  if (addToCartText == null) return;

  const agreements = [
    {
      checkbox: document.getElementById('productAgree'),
      attention: document.getElementById('productAgreeAttetion'),
    },
    {
      checkbox: document.getElementById('ageConfirm'),
      attention: document.getElementById('ageConfirmAttetion'),
    },
  ]
    .filter((item) => item.checkbox != null)
    .map((item) => ({
      ...item,
      alertMessage: item.checkbox.dataset.alertMessage || '',
    }));

  // 対象チェックボックスが1つもなければ何もしない
  if (agreements.length === 0) return;

  const isSoldOut = () => addToCartText.textContent === strSoldOut;
  const isAllChecked = () => agreements.every((item) => item.checkbox.checked);

  const updateButtonState = () => {
    if (isSoldOut()) return;

    if (isAllChecked()) {
      agreements.forEach((item) => {
        if (item.attention) item.attention.style.display = 'none';
      });
      addToCartButton.disabled = false;
    } else {
      addToCartButton.disabled = true;
    }
  };

  agreements.forEach((item) => {
    item.checkbox.addEventListener('click', function () {
      if (this.checked && item.attention) {
        item.attention.style.display = 'none';
      }
      updateButtonState();
    });
  });

  // 初期状態（未チェックなら購入ボタンを非アクティブ）
  updateButtonState();

  // 購入ボタンがクリックされたとき
  addToCartButton.addEventListener('click', (e) => {
    if (isSoldOut()) return;

    const unchecked = agreements.filter((item) => !item.checkbox.checked);
    if (unchecked.length === 0) return;

    e.preventDefault();
    unchecked.forEach((item) => {
      if (item.attention) item.attention.style.display = 'block';
    });
    alert(unchecked[0].alertMessage);
  });
})();
